import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import { ADMIN_EMAIL } from '../config/constants';
import { Button, Input, Card } from '../components/UI';
import Logo from '../components/Logo';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { language, changeLanguage } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validate admin credentials
    const result = login(email, password);
    
    if (result.success) {
      if (result.user.role === 'admin') {
        navigate('/liberado-jefe/dashboard');
      } else {
        setError('Access denied. Admin only.');
        setLoading(false);
      }
    } else {
      setError('Invalid email or password');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 px-4">
      {/* Header with Logo and Language */}
      <div className="absolute top-0 left-0 right-0 py-6 px-4">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <Logo size="medium" />
            <span className="text-xl font-bold text-white">LIBERADO</span>
          </div>
          
          {/* Language Selector */}
          <div className="flex items-center space-x-1 bg-purple-800 rounded-lg px-2 py-1">
            {['es', 'en', 'pt'].map((lang) => (
              <button
                key={lang}
                onClick={() => changeLanguage(lang)}
                className={`px-2 py-1 rounded text-sm font-medium transition ${
                  language === lang
                    ? 'bg-yellow-500 text-black'
                    : 'text-gray-300 hover:text-white'
                }`}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>

      <Card className="max-w-md w-full mt-20">
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">🔐</div>
          <h1 className="text-3xl font-bold mb-2">Admin Access</h1>
          <p className="text-gray-600">Panel de Administración</p>
        </div>

        <form onSubmit={handleSubmit}>
          <Input
            label="Email de Administrador"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
            required
            autoComplete="email"
          />

          <Input
            label="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            autoComplete="current-password"
          />

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
              {error}
            </div>
          )}

          <Button 
            type="submit" 
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-black"
            disabled={loading}
          >
            {loading ? 'Verificando...' : 'Acceder al Panel'}
          </Button>
        </form>

        <div className="text-center mt-4">
          <Link 
            to="/liberado-jefe-reset" 
            className="text-sm text-purple-600 hover:text-purple-800 underline"
          >
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <p className="text-center mt-4 text-sm text-gray-500">
          Solo acceso autorizado
        </p>
      </Card>
    </div>
  );
};

export default AdminLogin;
